class ProductGallery extends HTMLElement {
  constructor() {
    super();
    this.indicatorsContainer = this.querySelector('.product-gallery__indicators');
    this.galleryContainer = this.querySelector('.images-container'); // Assuming this container has the images
    this.querySelectorAll('img.js-hidden').forEach((img) => img.remove());
    this.activeIndex = 0;
  }

  connectedCallback() {
    this.resize();
    this.galleryContainer.addEventListener('scroll', this.updateActiveIndicator.bind(this));
    window.addEventListener('resize', this.resize.bind(this));
  }

  resize() {
    this.updateIndicators();
  }

  updateIndicators() {
    this.indicatorsContainer.innerHTML = ''; // Clear existing indicators
    const images = this.querySelectorAll('img');
    const template = this.querySelector('.gallery-indicator');

    images.forEach((image, index) => {
      const indicator = template.content.cloneNode(true).querySelector('li');
      const button = indicator.querySelector('button');
      button.setAttribute('data-index', index);
      button.setAttribute('aria-label', `Go to image ${index + 1}`); // Accessibility
      button.addEventListener('click', () => this.scrollToImage(index));
      this.indicatorsContainer.appendChild(indicator);
    });

    this.updateActiveIndicator();
  }

  addImageAtIndex(index, options) {
    const div = document.createElement('div');
    const img = document.createElement('img');

    Object.entries(options).forEach(([key, value]) => {
      img.setAttribute(key, value);
    });
    div.setAttribute('class', 'images-container__image');
    div.appendChild(img);

    const images = Array.from(this.querySelectorAll('.images-container__image'));
    if (index >= images.length) {
      this.galleryContainer.appendChild(div);
    } else {
      this.galleryContainer.insertBefore(div, images[index]);
    }

    this.updateIndicators();
  }

  deleteImageAtIndex(index) {
    const images = Array.from(this.querySelectorAll('.images-container__image'));
    if (images[index]) {
      images[index].remove();
    }

    this.updateIndicators();
  }

  scrollToImage(index) {
    const imageWidth = this.galleryContainer.clientWidth;
    this.galleryContainer.scrollTo({
      left: index * imageWidth,
      behavior: 'smooth',
    });
    this.activeIndex = index;
    this.updateActiveIndicator();
  }

  updateActiveIndicator() {
    const imageWidth = this.galleryContainer.clientWidth;
    this.activeIndex = Math.round(this.galleryContainer.scrollLeft / imageWidth);
    const indicators = this.indicatorsContainer.querySelectorAll('li');

    indicators.forEach((indicator, index) => {
      if (index === this.activeIndex) {
        indicator.setAttribute('data-active', '');
      } else {
        indicator.removeAttribute('data-active');
      }
    });
  }
}

customElements.define('product-gallery', ProductGallery);

var _title = document.querySelectorAll('.cmp-tabs_items .cmp-tabs_items-item');
if(_title) {
  _title.forEach((item) => {
    var _action = item.querySelector('.item-action');
    _action.addEventListener('click', (event) => {
      var target = event.currentTarget;
      var parent = target.parentElement
      if(parent.classList.contains('open')){
        parent.classList.remove('open');
      } else {
        var _title2 = document.querySelectorAll('.cmp-tabs_items .cmp-tabs_items-item');
        _title2.forEach((_item) => {
          if(_item == parent) {
            parent.classList.add('open');
          } else {
            _item.classList.remove('open');
          }
        });
      }
    });
  });
}